export { MODULE_API } from '../constants';
export const NAME = 'PROrders';
export const CRUMB_LABEL_KEY = 'PROrders';
export const CRUMB_LABEL_EDIT = 'edtPROrders';
export const CRUMB_LABEL_LIST = 'grdPROrders';

export const PRNAME = 'PROrdersParts';
export const PROrdersParts = <const>'PROrdersParts';
export const LOCALSTORAGE_STATE_KEY = 'DMS3_STATE';

export const EDFS_ORDER_TYPE = 'ZVA';

export const DEPENDENT_TABLES = <const>[
	PROrdersParts,
];

export const SHIP_TO_WH = 'SHIP_TO_WH';
export const X_VYROBEKND_OZN = 'X_VYROBEKND_OZN';
export const ND_NR = 'ND_NR';
export const TEXT = 'TEXT';
export const REMARK = 'REMARK';
export const MNOZSTVI_OBJ = 'MNOZSTVI_OBJ';
export const ODPOVED_PZN = 'ODPOVED_PZN';
export const POHLEDAVKA_PZN = 'POHLEDAVKA_PZN';
export const DISCOUNT_AMT = 'DISCOUNT_AMT';
export const DEFAULT_BRAND = 'V';
export const APPROVE_STATUS_ID = 3;
export const GENUINE_SUPPLIER_TYPE_ID = 1;
export const LOCAL_SUPPLIER_TYPE_ID = 2;
export const  EDFSId = "EDFSId";
export const GRNId = "GRNId";
export const BULK_UPLOAD ='Bulk Parts Upload';

export enum EMAIL_STATUS {
	SUBMIT = 1,
	CANCEL = 2
}

export enum ORDER_STATUS {
	CLOSED = 'CLOSED'
}

export const PARTS_COLS = {
	SHIP_TO_WH,
	X_VYROBEKND_OZN,
	ND_NR,
	TEXT,
	MNOZSTVI_OBJ,
	ODPOVED_PZN,
	POHLEDAVKA_PZN,
	DISCOUNT_AMT,
	REMARK,
};


export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum TAB_NAMES {
	HLAVNI = 'Hlavni',
}

export const TABS = {
	[TAB_NAMES.HLAVNI]: { id: TAB_NAMES.HLAVNI, labelKey: 'tsPROrders' },
};
